import CalendarsPage from "@pages/CalendarsPage/CalendarsPage";
import CalendarView from "@pages/CalendarsPage/CalendarView/CalendarView";
import MeetingLayout from "@pages/CalendarsPage/MeetingLayout";
import ScheduleSection from "@pages/CalendarsPage/ScheduleSection/ScheduleSection";
import SchedulingSection from "@pages/CalendarsPage/SchedulingSection/SchedulingSection";
import SettingsLayout from "@pages/SettingsPage/SettingsLayout";
import PersonalDetails from "@pages/SettingsPage/components/PersonalDetails";
import Username from "@pages/SettingsPage/components/Username";
import ChangePassword from "@pages/SettingsPage/components/ChangePassword";

import { Navigate, RouteObject } from "react-router-dom";
import { routerLoaders } from "router";
import ReferralMember from "@pages/SettingsPage/components/ReferralMember";
import Privacy from "@pages/SettingsPage/components/Privacy";
import CandidateTrackerPageStatic from "@pages/ActivityTracker/CandidateTrackerPageStatic";
import JobTrackPage from "@pages/JobTrackPage/JobTrackPage";
import JobTrackDetail from "@pages/JobTrackPage/JobTrackDetail/JobTrackDetail";
import DashboardPage from "@pages/Dashboard/Dashboard";
import CandidateTrackerPage from "@pages/ActivityTracker/CandidateTrackerPage";
import JobPageLayout from "@pages/candidate/JobPage/JobPageLayout";
import JobMatchesPage from "@pages/candidate/JobPage/JobMatchesPage/jobMatchesPage";
import JobMatchedDetailPage from "@pages/candidate/JobPage/JobMatchesPage/JobMatchedDetailPage";
import JobApplyPage from "@pages/JobApplyPage/JobApplyPage";
import ScheduleSection1 from "@pages/CalendarsPage/ScheduleSection/ScheduleSection1";
import AspirationPage from "@pages/candidate/AspirationPage/AspirationPage";
import AspirationPage2 from "@pages/candidate/AspirationPage2/AspirationPage2";

const { authLoader } = routerLoaders();

export const CandidateRoutes: RouteObject[] = [
  {
    path: "/dashboard",
    loader: authLoader,
    element: <DashboardPage />,
  },
  {
    path: "/job",
    loader: authLoader,
    element: <JobPageLayout />,
    children: [
      {
        index: true,
        element: <Navigate to={"job-matches"} />,
      },
      {
        path: "job-track",
        loader: authLoader,
        element: <JobTrackPage />,
      },
      {
        path: "job-matches",
        loader: authLoader,
        element: <JobMatchesPage />,
      },
    ],
  },
  {
    path: "/aspiration",
    loader: authLoader,
    element: <AspirationPage />,
  },
  {
    path: "/aspiration-2",
    loader: authLoader,
    element: <AspirationPage2 />,
  },
  {
    path: "/tracker",
    loader: authLoader,
    element: <CandidateTrackerPage />,
  },
  {
    path: "/tracker-clone",
    loader: authLoader,
    element: <CandidateTrackerPageStatic />,
  },
  {
    path: "apply-job/:id",
    loader: authLoader,
    element: <JobApplyPage />,
  },
  {
    path: "job-track-detail",
    element: <JobTrackDetail />,
  },
  {
    path: "job-matches-details",
    element: <JobMatchedDetailPage />,
  },
  {
    path: "/job-track",
    loader: authLoader,
    children: [
      {
        index: true,
        element: <JobTrackPage />,
      },
      {
        path: "job-track-detail",
        element: <JobTrackDetail />,
      },
    ],
  },
  {
    path: "/calendar",
    loader: authLoader,
    element: <MeetingLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="meeting" />,
      },
      {
        path: "meeting",
        element: <CalendarsPage />,
        children: [
          {
            index: true,
            element: <Navigate to="schedules" />,
          },
          {
            path: "schedules",
            element: <ScheduleSection />,
          },
          {
            path: "schedules1",
            element: <ScheduleSection1 />,
          },
          {
            path: "scheduling",
            element: <SchedulingSection />,
          },
          {
            path: "calendar-view",
            element: <CalendarView />,
          },
        ],
      },
    ],
  },
  {
    path: "/settings",
    loader: authLoader,
    element: <SettingsLayout />,
    children: [
      {
        index: true,
        element: <Navigate to={"account"} />,
      },
      {
        path: "account",
        children: [
          {
            index: true,
            element: <Navigate to={"personal-details"} />,
          },
          {
            path: "personal-details",
            element: <PersonalDetails />,
          },
          {
            path: "username",
            element: <Username />,
          },
          {
            path: "change-password",
            element: <ChangePassword />,
          },
          {
            path: "referral-member",
            element: <ReferralMember />,
          },
          {
            path: "privacy",
            element: <Privacy />,
          },
        ],
      },
    ],
  },
];
